/* Flavor fan (sections/sabores-abanico.liquid, Port des CO-Fächers „Sabores · Abanico“)
 * Fächer: Maus hebt die Karte unter dem Zeiger an, Klick wählt; Finger wählt beim Drüberfahren.
 * Die Karte unter dem Zeiger wird aus der Position über dem unbewegten Deck bestimmt (nicht aus der
 * Karte selbst), sonst rutscht die angehobene Karte unter dem Zeiger weg und flackert.
 * Add: window.LpCart.add (assets/lp-cart.js) mit `_origen: sabores`; Button-Zustände, Konfetti, Flug, Wippen und
 * cart:change (baseEvent lp:add, Drawer wird nur aktualisiert, öffnet sich nicht) kommen von dort.
 * Kartenstil: das quadratische Foto fliegt über LpCart.add; Tube-Stil: freigestellte Tube fliegt in Originalform. */
(() => {
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hoverDevice = () => matchMedia('(hover: hover) and (pointer: fine)').matches;
  const thumbImg = (src, size) => Object.assign(new Image(size, size), { src, alt: '' });

  class SaboresAbanico extends HTMLElement {
    connectedCallback() {
      this.deck = this.querySelector('[data-deck]');
      this.tilt = this.querySelector('[data-tilt]');
      this.word = this.querySelector('[data-deck-word]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.addBtn = this.querySelector('[data-add]');
      this.panel = this.querySelector('[data-panel]');
      this.errorEl = this.querySelector('[data-error]');
      if (!this.deck || this.cards.length < 2) return;

      this.active = Math.min(Number(this.dataset.active) || 0, this.cards.length - 1);
      this.hover = -1;
      this.dragging = false;
      this.lastType = '';
      this.ac = new AbortController();
      const opt = { signal: this.ac.signal };

      this.cards.forEach((card, i) => {
        // Maus/Finger laufen über das Deck; der Karten-Klick bleibt für die Tastatur.
        card.addEventListener('click', (e) => { if (e.detail === 0) this.select(i); }, opt);
      });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.select(i), opt));
      this.addBtn.addEventListener('click', () => this.add(), opt);

      this.deck.addEventListener('pointerdown', (e) => this.onDown(e), opt);
      this.deck.addEventListener('pointermove', (e) => this.onMove(e), opt);
      this.deck.addEventListener('pointerup', () => this.endDrag(), opt);
      this.deck.addEventListener('pointercancel', () => { this.dragging = false; this.untilt(); }, opt); // vertikales Scrollen hat übernommen
      this.deck.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        this.hover = -1;
        this.deck.style.cursor = '';
        this.layout();
        this.untilt();
      }, opt);
      this.deck.addEventListener('click', () => { if (this.lastType === 'mouse' && this.hover >= 0) this.select(this.hover); }, opt);

      document.addEventListener('cart:change', (e) => this.syncQty(e.detail && e.detail.cart), opt);
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.cards.indexOf(e.target.closest && e.target.closest('[data-card]'));
        if (i >= 0) this.select(i);
      }, opt);
      window.addEventListener('resize', () => this.layout(), opt);

      this.select(this.active, true);
    }

    disconnectedCallback() {
      if (this.ac) this.ac.abort();
    }

    /* ---------- Fächer ---------- */
    step() {
      return parseFloat(getComputedStyle(this.deck).getPropertyValue('--sab-step')) || 60;
    }

    rot() {
      return parseFloat(getComputedStyle(this.deck).getPropertyValue('--sab-rot')) || 9;
    }

    layout() {
      const n = this.cards.length, mid = (n - 1) / 2, step = this.step(), rot = this.rot();
      // Seitlicher Versatz nur um die Auswahl, nicht um die Hover-Karte: sonst rückt der ganze Fächer bei jeder
      // Mausbewegung hin und her.
      this.cards.forEach((card, i) => {
        const k = i - mid;
        let x = k * step, y = k * k * 7, r = k * rot, s = 1, z = 10 - Math.abs(k);
        if (i !== this.active) x += Math.sign(i - this.active) * step * 0.22;
        if (i === this.active) { y -= 34; r *= 0.25; s = 1.12; z = 30; }
        if (i === this.hover && i !== this.active) { y -= 20; r *= 0.5; s = 1.05; z = 25; }
        card.style.transform = `translateX(${x}px) translateY(${y}px) rotate(${r}deg) scale(${s})`;
        card.style.zIndex = Math.round(z * 2);
        card.classList.toggle('is-active', i === this.active);
        card.setAttribute('aria-pressed', i === this.active ? 'true' : 'false');
      });
    }

    select(i, quiet) {
      const changed = i !== this.active;
      this.active = i;
      const d = this.cards[i].dataset;
      this.style.setProperty('--sab-act', d.bg);
      this.addBtn.style.setProperty('--sab-btn', d.btn);
      this.addBtn.style.setProperty('--sab-btn-ink', d.btnInk);
      const soldout = d.available === 'false';
      this.addBtn.classList.remove('is-done', 'is-error');
      this.addBtn.classList.toggle('is-soldout', soldout);
      this.addBtn.disabled = soldout;
      this.classList.toggle('is-soldout-active', soldout);
      this.addBtn.setAttribute('aria-label', soldout ? `${d.name}: ${this.dataset.labelSoldout}` : (this.dataset.labelAdd || '').replace('[name]', d.name));

      const thumb = this.querySelector('[data-panel-thumb]');
      if (thumb) thumb.replaceChildren(...(d.thumb ? [thumbImg(d.thumb, 40)] : []));
      this.querySelector('[data-panel-name]').textContent = d.name;
      this.querySelector('[data-panel-price]').textContent = d.price;
      if (this.word) this.word.textContent = d.word;
      if (changed && this.panel && !reduceMotion()) {
        this.panel.classList.remove('is-swap');
        void this.panel.offsetWidth;
        this.panel.classList.add('is-swap');
      }
      this.dots.forEach((dot, k) => {
        dot.classList.toggle('is-active', k === i);
        dot.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      this.setQty(Number(d.qty) || 0);
      this.setError('');
      this.layout();
      if (changed && !quiet) this.hop(this.cards[i]);
    }

    // Slot unter dem Zeiger; `zone` = Breite je Slot. Hysterese: erst jenseits der Mitte + 0,2 wechseln.
    slotAt(e, current, zone) {
      const n = this.cards.length, mid = (n - 1) / 2;
      const r = this.deck.getBoundingClientRect();
      const raw = (e.clientX - (r.left + r.width / 2)) / zone + mid;
      let next = Math.abs(raw - mid) > mid + 1 ? -1 : Math.max(0, Math.min(n - 1, Math.round(raw)));
      if (current >= 0 && next >= 0 && Math.abs(raw - current) < 0.7) next = current;
      return next;
    }

    touchZone() {
      return Math.max(this.step(), this.deck.clientWidth / this.cards.length); // ganze Breite nutzbar
    }

    onDown(e) {
      this.lastType = e.pointerType;
      if (e.pointerType === 'mouse') return;
      this.dragging = true;
      this.scrubTo(this.slotAt(e, -1, this.touchZone()));
      this.tiltTo(e);
    }

    onMove(e) {
      if (e.pointerType === 'mouse') {
        const next = this.slotAt(e, this.hover, this.step());
        if (next !== this.hover) { this.hover = next; this.layout(); }
        this.deck.style.cursor = this.hover >= 0 ? 'pointer' : '';
        this.tiltTo(e);
        return;
      }
      if (!this.dragging) return;
      this.scrubTo(this.slotAt(e, this.active, this.touchZone()));
      this.tiltTo(e);
    }

    scrubTo(i) {
      if (i < 0 || i === this.active) return;
      this.select(i, true);
      if (navigator.vibrate) navigator.vibrate(6);
    }

    endDrag() {
      if (!this.dragging) return;
      this.dragging = false;
    }

    // Leichte 2D-Bewegung nur mit Maus (keine 3D-Neigung, siehe CSS-Kommentar an .sab__tilt).
    tiltTo(e) {
      if (e.pointerType !== 'mouse' || !hoverDevice() || reduceMotion()) return;
      const r = this.deck.getBoundingClientRect();
      if (!r.width || !r.height) return;
      const mx = Math.max(-0.5, Math.min(0.5, (e.clientX - r.left) / r.width - 0.5));
      const my = Math.max(-0.5, Math.min(0.5, (e.clientY - r.top) / r.height - 0.5));
      this.tilt.style.transition = 'transform .2s ease-out';
      this.tilt.style.transform = `translate(${mx * 10}px, ${my * 6}px) rotate(${mx * 3}deg)`;
    }

    untilt() {
      this.tilt.style.transition = '';
      this.tilt.style.transform = '';
    }

    hop(card) {
      const el = card && card.querySelector('.sab__hop');
      if (!el || reduceMotion() || !el.animate) return;
      el.animate([
        { transform: 'translateY(0) rotate(0)' },
        { transform: 'translateY(-26px) rotate(-6deg)', offset: 0.35 },
        { transform: 'translateY(0) rotate(4deg)', offset: 0.7 },
        { transform: 'translateY(-5px) rotate(-1deg)', offset: 0.85 },
        { transform: 'translateY(0) rotate(0)' },
      ], { duration: 620, easing: 'ease-out' });
    }

    /* ---------- Warenkorb ---------- */
    setQty(q) {
      const el = this.addBtn.querySelector('[data-qty]');
      el.textContent = q > 0 ? q : '';
      el.classList.toggle('is-on', q > 0);
    }

    syncQty(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      const byVariant = {};
      cart.items.forEach((it) => { byVariant[it.variant_id] = (byVariant[it.variant_id] || 0) + it.quantity; });
      this.cards.forEach((card) => { card.dataset.qty = byVariant[card.dataset.variant] || 0; });
      this.setQty(Number(this.cards[this.active].dataset.qty) || 0);
    }

    setError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = !msg;
    }

    // Nach einer 422-Antwort (kein Bestand mehr) die Sorte sofort als „Back soon“ zeigen.
    markSoldout(card) {
      if (card.dataset.available === 'false') return;
      card.dataset.available = 'false';
      card.classList.add('is-soldout');
      const label = document.createElement('span');
      label.className = 'sab__soon';
      label.textContent = this.dataset.labelSoldout;
      card.appendChild(label);
      const dot = this.dots[this.cards.indexOf(card)];
      if (dot) dot.classList.add('is-soldout');
    }

    async add() {
      const card = this.cards[this.active];
      const d = card.dataset;
      if (this.busy || d.available === 'false') return;
      if (!window.LpCart) { window.location.href = d.url; return; }
      this.busy = true;
      this.setError('');
      this.hop(card);
      const img = card.querySelector('img');
      const tube = this.dataset.style === 'tube';
      try {
        await LpCart.add({
          body: [{ id: Number(d.variant), quantity: 1, properties: { _origen: 'sabores' } }],
          button: this.addBtn,
          images: img && !tube ? [img] : [],
        });
        // Freigestellte Tube ohne quadratischen Zuschnitt fliegen lassen (LpCart.add schneidet quadratisch zu).
        if (img && tube) LpCart.fly(img, img.currentSrc || img.src, { natural: true }).then(() => LpCart.bump());
      } catch (err) {
        const noStock = err.status === 422;
        this.setError(noStock ? (err.message || this.dataset.labelNoStock) : this.dataset.labelError);
        if (noStock && Number(d.qty) === 0) {
          this.markSoldout(card);
          this.select(this.active, true);
          this.setError(err.message || this.dataset.labelNoStock);
        }
      } finally {
        this.busy = false;
      }
    }
  }

  if (!customElements.get('sabores-abanico')) customElements.define('sabores-abanico', SaboresAbanico);
})();
